import { useBubbleGetBubblePermissions } from "@crowdcoursing/api/bubble-permissions";

/**
 * Resolves effective bubble permissions (parent constraints applied) for gating UI actions.
 */
export function useBubbleEffectivePermissions(bubbleId: string | null | undefined, options?: { enabled?: boolean }) {
  const { data, isLoading, isError, refetch } = useBubbleGetBubblePermissions(bubbleId, options);

  return {
    canCreateEvents: data?.effective.canCreateEvents ?? true,
    constraints: data?.constraints,
    eventTimesRequireApproval: data?.effective.eventTimesRequireApproval ?? false,
    isError,
    isLoading,
    permissions: data,
    refetch,
  };
}
